import { api } from "./api";
import type { NeedsYouResponse } from "@/types/needsYou";

// HTTP_API.md `GET /api/v1/needs-you/{app_id}` — the app's ONE Needs-you
// list (blocking fixes, then decisions oldest first, then setup). The plain
// read is a shell probe on every route; `?include=updates` adds the bell's
// Updates news lines and is asked for only by the open Updates tab.
export async function fetchNeedsYou(
  appId: string,
  options: { includeUpdates?: boolean; signal?: AbortSignal } = {},
): Promise<NeedsYouResponse> {
  const { data } = await api.get<NeedsYouResponse>(
    `/api/v1/needs-you/${encodeURIComponent(appId)}`,
    {
      params: options.includeUpdates ? { include: "updates" } : undefined,
      signal: options.signal,
    },
  );
  return data;
}
